import React, { createContext, useContext, useState } from 'react';
import { useAuthToken } from './AuthTokenContext';
import axios from 'axios';

const UserContext = createContext();

export function UserProvider({ children }) {
  const { authAxios, setAuthToken } = useAuthToken();

  const baseUrl = process.env.REACT_APP_USER_API_URL;

  const login = async (email, password, authProvider='Local', externalToken='') => {
    const response = await axios.post(`${baseUrl}/participant/login`, {email, password, authProvider, externalToken});

    //TODO Check if token first
    setAuthToken(response.data.result.token);
    return response.data.result.token;
  };

  const register = async (email, password, currency, authProvider='Local', externalToken='') => {
    const response = await axios.post(`${baseUrl}/participant/register`, {email, password, currency, authProvider, externalToken});
    return response.data;
  };

  const changePassword = async () => {
    const response = await authAxios.post(`${baseUrl}/participant/`);
    return response.data;
  };

  const forgotPassword = async () => {
    const response = await axios.post(`${baseUrl}/participant/`);
    return response.data;
  };

  const verifyEmail = async (verificationCode) => {
    const response = await axios.post(`${baseUrl}/participant/verifyEmail`, { verificationCode});
    return response.data;
  }

  return (
    <UserContext.Provider value={{
      login,
      register,
      changePassword,
      forgotPassword,
      verifyEmail
    }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
